const LANGUAGE_TO_LOCALE: Record<string, string> = {
  fr: 'fr-FR',
  en: 'en-GB',
  pt: 'pt-PT',
};

export function getActiveLocale(): string {
  let lang = 'fr';
  try {
    const raw = localStorage.getItem('currentLanguage');
    lang = raw ? JSON.parse(raw) : 'fr';
  } catch {
    lang = 'fr';
  }
  return LANGUAGE_TO_LOCALE[lang] || 'fr-FR';
}
